<template>
  <sc-page-base
    title="Relatórios customizados"
    :loading="loading">

    <div class="box">
      <sc-input
        icon="search"
        placeholder="Nome do relatório"
        @input="setReportName"
        expanded/>
    </div>

    <sc-table-empty v-if="!filteredReports || filteredReports.length === 0" />

    <div
      class="page-bi-reports__wrap-content"
      v-if="filteredReports && filteredReports.length > 0">
      <section
        v-for="(report, index) of filteredReports"
        :key="index"
        class="page-bi-reports__wrap-content__item">

        <sc-card
          class="page-bi-reports__card"
          :link="true">

          <template slot="image">
            <figure
              class="page-bi-reports__card__figure">
              <router-link
                class="page-bi-reports__card__link"
                :to="toBiView(report)">
                <img
                  class="page-bi-reports__card__image"
                  :src="report.image" />
              </router-link>
            </figure>
          </template>

          <template slot="body">
            <div class="page-bi-reports__card__content">
              <p class="title is-6">
                <router-link
                  :to="toBiView(report)"
                  class="page-bi-reports__card__full-link">
                  <span class="has-text-truncated page-bi-reports__card__full-link__text">{{ report.title }}</span>
                  <sc-icon :icon="report.icon"/>
                </router-link>
              </p>
            </div>
          </template>
        </sc-card>

      </section>
    </div>

  </sc-page-base>
</template>

<script>
  import {
    ScPageBase,
    ScCard,
    ScIcon,
    ScTableEmpty,
    ScInput,
  } from '@intelipost-js/secure-components';
  import { createNamespacedHelpers } from 'vuex';

  const { mapState, mapGetters, mapActions, mapMutations } = createNamespacedHelpers('analytic/bi');

  export default {
    name: 'page-bi-reports',
    computed: {
      ...mapGetters([
        'filteredReports',
      ]),
      ...mapState([
        'loading',
      ]),
    },
    methods: {
      ...mapActions([
        'getReports',
      ]),
      ...mapMutations([
        'setReportName',
      ]),
      toBiView({ title, url }) {
        return {
          name: 'bi-view',
          params: {
            title,
            url,
          },
        };
      },
    },
    created() {
      this.getReports()
        .catch(() => {
          this.$router.push({
            name: 'dashboard',
          });
        });
    },
    components: {
      ScPageBase,
      ScCard,
      ScIcon,
      ScTableEmpty,
      ScInput,
    },
  };
</script>

<style lang="scss" scoped>
  @import "~@intelipost-js/secure-ui/src/scss/variables"; // eslint-disable-line

  $animationEaseInOut: all ease-in-out 0.3s;

  .page-bi-reports {
    &__wrap-content {
      display: flex;
      flex-flow: row wrap;
      justify-content: flex-start;

      @media (max-width: 768px) {
        flex-direction: column;
      }

      &__item {
        flex-grow: 0;
        width: 330px;
        padding: 1rem;

        @media (min-width: 1250px) {
          height: 312px;
        }

        @media (max-width: 768px) {
          padding: 1rem 0;
        }

        @media (max-width: 500px) {
          width: 280px;
        }
      }
    }

    &__card {
      height: 280px;
      min-height: 280px;
      transition: $animationEaseInOut;

      @media (max-width: 768px) {
        height: 305px;
      }

      @media (max-width: 500px) {
        height: 268px;
        min-height: auto;
      }

      &__full-link {
        &__text {
          font-size: 0.95rem;
          line-height: 24px;
          max-width: 240px;
        }
      }

      &__content {
        transition: $animationEaseInOut;
      }

      &__link {
        display: flex;
        align-items: center;
        justify-content: center;

        height: 222px;
        width: 100%;
        opacity: 1;
        transition: $animationEaseInOut;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/bi-reports/PageBiReports.vue?6f805c89